<template>
    <div v-if="client">
        <!-- login settings -->
        <p class="title is-5">Login settings</p>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Login types</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div v-for="([type, { label }], index) in Object.entries(loginTypes)" :key="index" class="switch-item">
                        <input :id="type"
                               type="checkbox"
                               :name="type"
                               class="switch"
                               v-model="loginTypes[type].allowed">
                        <label :for="type">{{label}}</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Phone Mask</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.loginSettings.phoneMask" class="input oc-input" type="text" />
                        <span class="help">E.g. +{123} 000-000-000</span>
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Country codes for phone mask</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.loginSettings.countriesPhoneMask" class="input oc-input" type="text" />
                        <span class="help">E.g.: IN,CN,RU,AM</span>
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label is-horizontal">
                <label class="label">Email Two Factor Auth</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.loginSettings.email2FaEnabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <div class="field-body">
            <div class="field is-grouped">
                <div class="control">
                    <button @click="save" class="button is-primary">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import state from '../../../../state'
    import utils from '../../../../utils'
    import clientService from '../../../../services/client.service'

    export default {
        name: 'client-settings-login',
        data() {
            return {
                client: null,
                loginTypes: {
                    login: { allowed: false, label: 'Login/password' },
                    pin: { allowed: false, label: 'Pin' }
                },
            }
        },
        computed: {
            clientId() {
                return Number(this.$route.params.clientId)
            },
            allowedLoginTypes() {
                return Object.entries(this.loginTypes).filter(([_, { allowed }]) => !!allowed)
            }
        },
        watch: {
            clientId() {
                this.loadClient()
            }
        },
        async mounted() {
            await clientService.ensure()
            this.loadClient()
        },
        methods: {
            loadClient() {
                this.client = utils.clone(state.clients.getClient(this.clientId));
                this.initLoginTypes();
            },
            initLoginTypes() {
                if (!this.client.settings.loginSettings.loginTypes) return
                this.client.settings.loginSettings.loginTypes.forEach(type => {
                    this.loginTypes[type].allowed = true
                })
            },
            async save() {
                this.client.settings.loginSettings.loginTypes = this.allowedLoginTypes.map(([type, _]) => type)
                await clientService.save(this.client)
            },
        },
    }
</script>

<style scoped>
    .switch-item {
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/login.vue